import audio from '../audio/Voice 005.m4a';
import SamiLogo from '../images/sami logo cemintic.png';
// import EslamLogo from 'https://images.rawpixel.com/image_social_landscape/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIzLTEyL2ZyZWVpbWFnZXNjb21wYW55X2JsYWNrX3RleHR1cmVfb2ZfZG90dGVkX2FydF90ZXh0dXJlX2JhY2tncm91bl9hY2RiMTRmOS01MzEwLTRiZTUtYjdmNC04NGM2ZDU0N2I5NTlfMS5qcGc.jpg';
import Header from './header';

export const Home = () => {

  const sayHello = () => {
    const audio = document.querySelector('#background-audio')
    audio.play();
  }
  
   return (
    <>
      <section id="home">
        <Header />
        <main className="flex-column flex-md-row">
      <div className="intro mt-5">
        <h1 className="mt-5">
          <span
            style={{
              textTransform: "uppercase",
              fontSize: 24,
              lineHeight: "1.3",
              letterSpacing: 7,
              fontWeight: 400,
              marginBottom: 10
            }}
          >
            Hello, I'm{" "}
          </span>
          <audio id="background-audio" preload="auto" autoPlay="">
            <source
              src={audio}
              type="audio/mpeg"
            />
          </audio>
          <br />
          <span
            className="text-wrap eslamName"
            style={{ fontSize: 80, color: "#fff" }}
          >
            Sami M. <span>Balabel</span> 
          </span>
        </h1>
        <h2
          className="mt-5 text-wrap text-capitalize text-white d-block"
          style={{ fontSize: 24, lineHeight: 2 }}
        >
          A Passionate <span className="highlight typewriter" />
        </h2>
        <a href="#contactUs" className="say-hello mt-5 btn btn-outline-success d-block" onClick={sayHello}>
          SAY HELLO
        </a>
      </div>
      <div className="mt-5">
        <div className="profile-image mt-5">
          <img
            // src="https://thames-demo-nuxt.vercel.app/images/slider/person.png"
            src={SamiLogo}
            className="mainImage"
            alt="Profile Icon"
            // الإضافات الجديدة هنا:
            fetchpriority="high" // أولوية قصوى
            loading="eager"       // تحميل فوري
          />
          {/* <img
            src={overlay}
            className="center-image"
            alt="Overlay Icon"
          /> */}
        </div>
        {/* <div className="social-links d-flex flex-column gap-3 p-3 m-3 mt-5">
          <div className="btn btn-outline-success btn-md-lg btn btn-sm-sm">
            <a href="#">
              <i className="fa-brands fa-facebook-f" />
            </a>
          </div>
          <div className="btn btn-outline-success btn-md-lg btn btn-sm-sm">
            <a href="#">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </div>
          <div className="btn btn-outline-success btn-md-lg btn btn-sm-sm">
            <a href="#">
              <i className="fa-brands fa-instagram" />
            </a>
          </div>
          <div className="btn btn-outline-success btn-md-lg btn btn-sm-sm">
            <a href="#">
              <i className="fa-brands fa-youtube" />
            </a>
          </div>
        </div> */}
      </div>
    </main>
      </section>
    </>
  );
} 

export default Home;
